import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  BaseCurrencyResponse,
  ProductCurrencyRateRequest,
  ProductCurrencyRateResponse
} from '../models/producto-currency-rate.model';

/**
 * Tipos de cambio del negocio (Incidente #52 — submódulo Monedas).
 * El backend infiere el businessId desde el JWT (SecurityContextUtil), por lo que
 * ninguna de estas llamadas envía businessId por query.
 */
@Injectable({
  providedIn: 'root'
})
export class ProductoCurrencyRateApiService {
  private readonly apiUrl = `${environment.apiUrl}api/product-currency-rates`;

  constructor(private http: HttpClient) { }

  /** Moneda base actual del negocio (null si aún no configurada). */
  getBaseCurrency(): Observable<BaseCurrencyResponse | null> {
    return this.http.get<BaseCurrencyResponse | null>(`${this.apiUrl}/base`);
  }

  /** Fijar la moneda base del negocio. 400 si la moneda no existe. */
  setBaseCurrency(currencyId: number): Observable<BaseCurrencyResponse> {
    const params = new HttpParams().set('currencyId', currencyId.toString());
    return this.http.put<BaseCurrencyResponse>(`${this.apiUrl}/base`, null, { params });
  }

  /** Listado de tipos de cambio del negocio. */
  getRates(): Observable<ProductCurrencyRateResponse[]> {
    return this.http.get<ProductCurrencyRateResponse[]>(this.apiUrl);
  }

  /** Crear/actualizar (upsert por moneda). 400 si rateToBase <= 0 o moneda inexistente. */
  upsertRate(req: ProductCurrencyRateRequest): Observable<ProductCurrencyRateResponse> {
    return this.http.put<ProductCurrencyRateResponse>(this.apiUrl, req);
  }

  /** Eliminar el tipo de cambio de una moneda. 400 si es la moneda base, 404 si no existe. */
  deleteRate(currencyId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${currencyId}`);
  }
}
